export const COMPETITORS = [
	{
		slug: 'maintainx',
		name: 'MaintainX',
		comparison: [false, true, false, false, true, false, false, true, false, false, 2],
		header: 'Why more teams choose <span style="color: var(--primary)">facility</span>bot over MaintainX',
		descriptions: [
			'FacilityBot empowers facilities teams with automated workflows, smart scheduling, and chatbot-based ticketing. In contrast to MaintainX, FacilityBot focuses on simplifying operations without sacrificing flexibility.',
			"Here's how FacilityBot compares with MaintainX in key areas.",
		],
	},
	{
		slug: 'maximo',
		name: 'Maximo',
		comparison: [false, true, false, false, true, false, false, true, false, true, 3],
		header: 'A modern Maximo alternative: <span style="color: var(--primary)">facility</span>bot',
		descriptions: [
			"While Maximo is known for its robust features, FacilityBot delivers similar capabilities with far less complexity and cost. It's ideal for teams seeking agility, automation, and scalability without the enterprise bloat.",
			'See the key differences between FacilityBot and IBM Maximo below.',
		],
	},
	{
		slug: 'fiix',
		name: 'FiiX',
		comparison: [false, true, false, true, true, false, false, true, false, true, 2],
		header: '<span style="color: var(--primary)">facility</span>bot delivers more agility than Fiix',
		descriptions: [
			'FacilityBot offers a cloud-native CMMS designed for fast, efficient maintenance workflows. Unlike Fiix, FacilityBot is built to be user-friendly right out of the box—no steep learning curve.',
			'Check out how FacilityBot stacks up against Fiix in this side-by-side comparison.',
		],
	},
	{
		slug: 'emaint',
		name: 'eMaint',
		comparison: [false, true, false, false, true, false, false, true, false, true, 2],
		header: 'See why <span style="color: var(--primary)">facility</span>bot is the top choice over eMaint',
		descriptions: [
			"With FacilityBot's Smart Facilities Management platform, building owners and managers enjoy an intuitive, mobile-first experience that makes automation and task tracking easier than ever.",
			"We've outlined below how FacilityBot compares to eMaint in terms of usability, automation, and value.",
		],
	},
	{
		slug: 'limble',
		name: 'Limble',
		comparison: [false, true, false, false, true, false, false, true, false, true, 2],
		header: '<span style="color: var(--primary)">facility</span>bot offers simplicity and scale beyond Limble',
		descriptions: [
			"Designed for busy facility teams, FacilityBot's platform simplifies asset and maintenance management. Compared to Limble, it provides faster onboarding, better mobile access, and seamless chatbot integration.",
			'Explore the key differences between FacilityBot and Limble below.',
		],
	},
	{
		slug: 'efacility',
		name: 'eFacility',
		comparison: [false, true, false, false, true, false, false, false, true, false, 'unknown'],
	},
	{
		slug: 'planon',
		name: 'Planon',
		comparison: [false, false, false, false, true, true, false, true, true, false, 3],
		header: 'Why <span style="color: var(--primary)">facility</span>bot is the flexible alternative to Planon',
		descriptions: [
			'Planon offers a wide suite of tools, but FacilityBot stands out for its lightweight deployment, smart chatbot interface, and faster implementation time.',
			'Read on to compare FacilityBot with Planon and choose the right fit for your team.',
		],
	},
	{
		slug: 'spacewell',
		name: 'Spacewell',
		comparison: [false, true, false, true, true, true, false, true, false, true, 'unknown'],
		header: '<span style="color: var(--primary)">facility</span>bot vs Spacewell: The smart choice for FM automation',
		descriptions: [
			'FacilityBot combines the power of a CMMS with chatbot-based ticketing and real-time automation, offering a leaner solution than Spacewell.',
			"We've detailed the core advantages of FacilityBot compared to Spacewell to help you decide.",
		],
	},
];
